import { render, staticRenderFns } from "./virkailija.vue?vue&type=template&id=48d0ead9&scoped=true&"
import script from "./virkailija.vue?vue&type=script&lang=ts&"
export * from "./virkailija.vue?vue&type=script&lang=ts&"
import style0 from "./virkailija.vue?vue&type=style&index=0&id=48d0ead9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d0ead9",
  null
  
)

export default component.exports